import { IRaygunConfig } from '@anghami/neoanalytics/dist/interfaces';
import { environment } from 'env/environment';

/**
 * Same-origin noise that the SDK's `ignore3rdPartyErrors` cannot see.
 *
 * That option drops stacks that never touch our origin (browser extensions, Zendesk's
 * snippet, frameless "chrome: call method" timeouts), but not scripts a wallet injects
 * into the page itself, whose frames point at our own URL. None of these identifiers
 * exist in this repo; each entry is taken from this app's own Raygun groups.
 */
const IGNORED_MESSAGES: string[] = [
  // Brave's wallet script resetting `window.ethereum.selectedAddress` on every page.
  'window.ethereum',
  // Firefox for iOS scripts (reader mode, YouTube quality) injected into every page.
  '__firefox__'
];

/**
 * Raygun bills per error instance. In August 2026 a single Chrome extension produced
 * 3.39M billed instances in four days and capped the shared plan, which stopped ingestion
 * for every Anghami app on it, this one included.
 *
 * The SDK defends by default: `ignore3rdPartyErrors` drops extension-origin stacks and
 * the noise guard rate-limits everything else. This config adds the creators deny-list
 * on top.
 */
export const raygunConfig: IRaygunConfig = {
  key: environment.raygun || '',
  customConfigs: {
    // Staging and dev run on *.angha.me and share the production API key, so without
    // this they burn production quota and are indistinguishable in the dashboard.
    // Matched against location.hostname as a regex by Raygun4JS.
    excludedHostnames: ['localhost', '\\.angha\\.me$']
  },
  // XHR request/response bodies were being attached to every breadcrumb, which inflates
  // each payload and captured artist emails and phone numbers in practice.
  logContentsOfXhrCalls: false,
  noiseGuard: {
    ignoredMessages: IGNORED_MESSAGES
  }
};
